<template>
  <div>构建接口文档</div>
</template>

<script>
  export default {
    name: "add-documentation"
  }
</script>

<style scoped>

</style>
